import { create } from 'zustand';
import { RequestStrategyEnum } from '@shared/api/models';

import { GetSurveyResponse, SurveyApi } from '@shared/api/rest/survey';
import { ApiUtils } from '@shared/utils';

interface getImageType {
  data: string;
  loading: boolean;
  error: string | null;
  success: boolean | null;
  get: (surveyId: string, clientId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetImageStore = create<getImageType>((set) => ({
  data: '',
  loading: false,
  error: null,
  success: null,

  get: ApiUtils.wrapperApi(async (surveyId: string, clientId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null, success: null });
      const result = await SurveyApi.getImage(surveyId, clientId, signal);
      const blob = new Blob([result.data], { type: result.contentType });
      const imageUrl = URL.createObjectURL(blob);
      set({ data: imageUrl ?? [], loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: '', loading: false, error: null, success: null }),
}));
